import { httpClient } from "@/app/shared/shared-services/httpClient";
import { environment } from "@/environment";

const URL = environment.loyaltyApiBaseUrl;
const SYNCED_COUPON_NAME_PREFIX = "yaseer_sync_";

// Synced coupons are hidden from every place we list coupons.
const excludeSyncedCoupons = (queryString) => {
  const condition = `name||$excl||${SYNCED_COUPON_NAME_PREFIX}`;
  // Table filters may send an OR group, the exclusion has to be applied on both sides of it.
  return queryString.includes('or[]=')
    ? `${queryString}&filter[]=${condition}&or[]=${condition}`
    : `${queryString}&filter=${condition}`;
};

export default {
  async fetchCoupons(query) {
    // const queryString = `${query}&join=app`;
    const queryString = excludeSyncedCoupons(query ? `${query}&join=app` : '?join=app');
    const url = `${URL}v1/coupons${queryString}`;
    return (await httpClient.get(url)).data;
  },
  async createCoupon(coupon) {
    const url = `${URL}v1/coupons`;
    return await httpClient.post(url, coupon);
  },
  async updateCoupon(coupon) {
    const url = `${URL}v1/coupons/${coupon.id}`;
    return await httpClient.put(url, coupon);
  },
  async removeCoupon(couponId) {
    const url = `${URL}v1/coupons/${couponId}`;
    return await httpClient.delete(url);
  },
};
